var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"contendordepagina"},[_c('div',[_c('div',{staticClass:"alert alert-danger",staticStyle:{"margin-top":"100px"}},[_vm._v("Página no encontrada")])])])}
var staticRenderFns = []

export { render, staticRenderFns }